const NullComponent = () => null;

export const getModComponent = <T,>(Component: T) => {
  if (Component) {
    return Component;
  }

  return NullComponent;
};
